import { render, staticRenderFns } from "./ConsentText.vue?vue&type=template&id=65ed4a2a&scoped=true"
import script from "./ConsentText.vue?vue&type=script&lang=js"
export * from "./ConsentText.vue?vue&type=script&lang=js"
import style0 from "./ConsentText.vue?vue&type=style&index=0&id=65ed4a2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed4a2a",
  null
  
)

export default component.exports